import { Buffer } from 'buffer'
import { AuthService } from '../service/auth.service';
import { PoSelectOption } from '@po-ui/ng-components';
import * as moment from 'moment';

export interface IFiltroLista {
  page: number;
  pageSize: number;
  filter: string;
  order: string;

}

export abstract class FiltroLista {

  abstract dados: IFiltroLista ;

  dadoOriginal: {} = {};
  id: number = 0;
  auth_user_id: string = '';
  chave: string = '';
  timeout: string = ''

  listaPaginacao: Array<PoSelectOption> = [
    {value: 20 , label: '20'},
    {value: 50 , label: '50'},
    {value: 100, label: '100'},
    {value: 200, label: '200'},
    {value: 0  , label: 'Sem Paginação'},
  ]

  listaConciliado: Array<PoSelectOption> = [
    {value: '1', label: 'Sim'},
    {value: '2', label: 'Não'},
    {value: ' ', label: 'Todos'}
  ]

  constructor (
    public authService: AuthService,
    private par_chave: string,
    private par_timeout: string = '',
  ){
    this.chave = par_chave;
    this.timeout = par_timeout;
  }

  async init(): Promise<boolean> {

    this.auth_user_id = (await this.authService.getUsuarioSessao()).CUSRID;

    return new Promise((resolve, reject) => {

      this.authService.getUserProfileByChave(this.auth_user_id,this.chave).subscribe({
        next: (ret) => {

          let dadosRetorno = Buffer.from(ret.CDADOS, 'base64').toString('ascii');

          function parseDate(k: string, v: string) {
            if (k.substring(0,1) === "D" && v.includes("T")) {
              return new Date(v);
            }
            return v;
          }

          let dadosAuxiliar = JSON.parse(dadosRetorno,parseDate);

          this.dados = this.setDefault();

          if (new Date(ret.CTIMEOUT) >= new Date()){

            Object.keys(dadosAuxiliar).some(key => {

              if (key in this.dados){
                // @ts-ignore
                this.dados[key] = dadosAuxiliar[key];
              }
            })

            this.dadoOriginal = JSON.parse(dadosRetorno,parseDate);

          } else {
            // mantenho o page size escolhido pelo usuario mesmo com timeout vencido
            if ('pageSize' in dadosAuxiliar){
              this.dados.pageSize = dadosAuxiliar.pageSize;
            }
          }

          this.id = ret.NID;
          resolve(true)
        },
        error: () => {
          this.dados = this.setDefault();
          resolve(true)
        }
      })
    })
  }

  public abstract setDefault(): IFiltroLista;

  public getData = (dias: number = 0): Date => {
    const data = new Date();
    data.setDate(data.getDate() + dias);
    data.setHours(0, 0, 0, 0);
    return data;
  }

  public getDataString = (dias: number = 0): string => {
    const data = new Date();
    data.setDate(data.getDate() + dias);
    return data.toISOString().substring(0,10);
  }

  public postSalvarFiltro(): void{

    if (JSON.stringify(this.dados) != JSON.stringify(this.dadoOriginal)){
      let dadosEnviar = {
        NID: this.id,
        CUSRID: this.auth_user_id,
        CCHAVE: this.chave,
        CTIMEOUT: this.timeout,
        CDADOS: Buffer.from(JSON.stringify(this.dados)).toString("base64"),
      }
      this.authService.postUserProfile(dadosEnviar).subscribe({
        next: (ret) => {
          this.id = ret.NID;
        }
      })
    }
  }

}
